export default {
  videos: [
    {
      id: 2,
      videoUrl: '//res001.geekbang.org/resource/video/l_f7322c38150a5c0c44f5474c453d1bfb.mp4',
      imgUrl: require('../../static/img/video/xu.jpg'),
      title: '编程的意义就是让世界变得有趣一些',
      writer: 'Go 语言狂人许式伟'
    },
    {
      id: 5,
      videoUrl: '//res001.geekbang.org/resource/video/760e1087501b56fc957b3e90f211ef9b.mp4',
      imgUrl: require('../../static/img/video/dao.jpg'),
      title: '我人生有两大选择，为的却都是同一件事',
      writer: '道哥'
    },
    {
      id: 1,
      videoUrl: '//res001.geekbang.org/resource/video/860e874b7281f963ae35762ed5332b64.mp4',
      imgUrl: require('../../static/img/video/zuo.jpg'),
      title: '技术一定会让人失业，但我没有生不逢时',
      writer: '左耳朵耗子'
    },
    {
      id: 4,
      videoUrl: '//res001.geekbang.org/resource/video/d52a485e6388b4900b24d2baaa790734.mp4',
      imgUrl: require('../../static/img/video/hu.jpg'),
      title: '通往CTO的道路上就是四个字......',
      writer: '360 胡宁'
    },
    {
      id: 3,
      videoUrl: '//res001.geekbang.org/resource/video/61928f90a0dba3914dbc00357353994e.mp4',
      imgUrl: require('../../static/img/video/cui.jpg'),
      title: '让自己写的代码跑在每个人的电脑上',
      writer: '崔宝秋'
    },
    {
      id: 6,
      videoUrl: '//res001.geekbang.org/resource/video/2c3a01f842e2a5a1950c24bbed245d82.mp4',
      imgUrl: require('../../static/img/video/niao.jpg'),
      title: '从留级打架问题学生到PHP大神，他的人生驱动力竟然是？',
      writer: '链家鸟哥'
    }
  ]
}
